/* eslint-disable no-alert */
/* eslint-disable spire/export-styles */
import colorPallete, { labelFonts, themeFontWeights } from "@DSG/MobiusOverrides/styles/variables";
import { getCookie } from "@insite/client-framework/Common/Cookies";
import useGoogleMaps from "@insite/client-framework/Common/Hooks/useGoogleMaps";
import useLocationFilterSearch, { LocationModel } from "@insite/client-framework/Common/Hooks/useLocationFilterSearch";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import withDynamicGoogleMaps from "@insite/client-framework/Common/withDynamicGoogleMaps";
import Zone from "@insite/client-framework/Components/Zone";
import { getDealers, GetDealersApiParameter } from "@insite/client-framework/Services/DealerService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    getDealersDataView,
    getDealersDefaultLocation,
} from "@insite/client-framework/Store/Data/Dealers/DealersSelectors";
import loadDealers from "@insite/client-framework/Store/Data/Dealers/Handlers/LoadDealers";
import resetDealers from "@insite/client-framework/Store/Data/Dealers/Handlers/ResetDealers";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import displayDealer from "@insite/client-framework/Store/Pages/DealerDetails/Handlers/DisplayDealer";
import setParameter from "@insite/client-framework/Store/Pages/LocationFinder/Handlers/SetParameter";
import translate from "@insite/client-framework/Translate";
import { DealerModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import {
    NavigationModeCookieName,
    NavigationModeMenuStyles,
} from "@insite/content-library/Components/NavigationModeMenu";
import { ShowInventoryToggleStyles } from "@insite/content-library/Components/ShowInventoryToggle";
import { ShowPricingToggleStyles } from "@insite/content-library/Components/ShowPricingToggle";
import Hidden from "@insite/mobius/Hidden";
import Icon from "@insite/mobius/Icon";
import MapPin from "@insite/mobius/Icons/MapPin";
import Link from "@insite/mobius/Link";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import injectCss from "@insite/mobius/utilities/injectCss";
import * as cssLinter from "css";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";
const enum fields {
    customCSS = "customCSS",
    showPricingToggle = "showPricingToggle",
    showInventoryToggle = "showInventoryToggle",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.customCSS]: string;
        [fields.showPricingToggle]: boolean;
        [fields.showInventoryToggle]: boolean;
    };
    useLoadScript: ({ googleMapsApiKey }: { googleMapsApiKey: any }) => { isLoaded: boolean };
}
const mapDispatchToProps = {
    loadDealers,
    setParameter,
    resetDealers,
    displayDealer,
};
const mapStateToProps = (state: ApplicationState) => ({
    enableWarehousePickup: getSettingsCollection(state).accountSettings.enableWarehousePickup,
    displayPricingAndInventory: state.context.session?.displayPricingAndInventory || false,
    currentMode: getCookie(NavigationModeCookieName) || "Storefront",
    isAuthenticated: state.context.session.isAuthenticated,
    account: state.pages.accountSettings.editingAccount,
    pickUpWarehouse:
        state.context.session.pickUpWarehouse || state.pages.accountSettings.editingAccount?.defaultWarehouse,
    session: state.context.session,
    settings: getSettingsCollection(state),
    getDealersParameter: state.pages.locationFinder.getDealersParameter,
    dealersDataView: getDealersDataView(state, state.pages.locationFinder.getDealersParameter),
    dealersDefaultLocation: getDealersDefaultLocation(state),
    dealerDetailsUrl: getPageLinkByPageType(state, "DealerDetailsPage")?.url,
    dealersPageUrl: getPageLinkByPageType(state, "LocationFinderPage")?.url,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const Navigation = styled.div`
    color: ${colorPallete.grey800};
    font-size: ${labelFonts.label1Regular.fontSize};
    line-height: ${labelFonts.label1Regular.lineHeight};
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

const NavItem = styled.span<InjectableCss>`
    display: inline-flex;
    align-items: center;

    > span {
        margin-left: 4px;
        a {
            font-size: ${labelFonts.label1SemiBold.fontSize};
            line-height: ${labelFonts.label1SemiBold.lineHeight};
            font-weight: ${themeFontWeights.semiBold};
        }
    }

    > .closest-title {
        &:empty {
            margin-left: 0;
        }
        &:not(:empty) + span a {
            margin-left: 16px;
        }
        > span {
            a {
                font-size: ${labelFonts.label1Regular.fontSize};
                line-height: ${labelFonts.label1Regular.lineHeight};
                font-weight: ${themeFontWeights.regular};
            }
        }
    }

    > .find-location a {
        font-size: ${labelFonts.label2SemiBold.fontSize};
        line-height: ${labelFonts.label2SemiBold.lineHeight};
        font-weight: ${themeFontWeights.semiBold};
    }
    ${injectCss}
`;

export interface NearestBranchInformationStyles {
    wrapper?: InjectableCss;
    navigationModeMenu?: NavigationModeMenuStyles;
    showInventoryLink?: InjectableCss;
    showInventoryToggle?: ShowInventoryToggleStyles;
    showPricingLink?: InjectableCss;
    showPricingToggle?: ShowPricingToggleStyles;
    currencyLink?: InjectableCss;
    languageLink?: InjectableCss;
    warehousePickupLink?: InjectableCss;
    signInLink?: InjectableCss;
}

export const nearestBranchInformationStyles: NearestBranchInformationStyles = {
    wrapper: {
        css: css`
            padding: 0;
            height: auto;
        `,
    },
    showInventoryLink: {
        css: css`
            margin-left: 10px;
        `,
    },
    showPricingLink: {
        css: css`
            margin-left: 10px;
        `,
    },
    currencyLink: {
        css: css`
            margin-left: 16px;
        `,
    },
    languageLink: {
        css: css`
            flex: 0 0 auto;
            margin-left: 16px;
        `,
    },
    warehousePickupLink: {
        css: css`
            flex: 0 1 auto;
            margin-left: 6px;
            min-width: 30px;
        `,
    },
    signInLink: {
        css: css`
            flex: 0 0 auto;
        `,
    },
};

const defaultCustomCss = `.wrapper {
}

.navigation-mode-menu {
}

.currency-menu {
}

.language-menu {
}

.ship-to-address-menu {
}

.sign-in-link {
}`;

const NearestBranchInformation: FC<Props> = ({
    id,
    fields,
    isAuthenticated,
    pickUpWarehouse,
    settings,
    dealersDataView,
    dealersDefaultLocation,
    getDealersParameter,
    loadDealers,
    resetDealers,
    setParameter,
    useLoadScript,
    dealersPageUrl,
}) => {
    const styles = nearestBranchInformationStyles;

    const customCssWrapper = {
        css: css`
            ${fields.customCSS}
        `,
    };
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const handleLoadLocations = (parameter: GetDealersApiParameter) => {
        setParameter(parameter);
    };

    React.useEffect(() => {
        if (getDealersParameter) {
            loadDealers(getDealersParameter);
        }
        return () => resetDealers();
    }, [getDealersParameter]);

    // Manage Google Maps State
    const { googleMapsApiKey } = settings.websiteSettings;
    const { isLoaded } = useLoadScript({ googleMapsApiKey });
    const { currentLocation, isGoogleMapsScriptsLoaded, setMapCenter } = useGoogleMaps({
        isShown: true,
        isLoaded,
    });

    // eslint-disable-next-line no-console

    // Manage Selected Dealer
    const [selectedDealer, setSelectedDealer] = React.useState<DealerModel | undefined>(undefined);
    const [showSelectedDealer, setShowSelectedDealer] = React.useState<boolean>(false);
    const [defaultRadius, setDefaultRadius] = React.useState<number>(0);

    // Manage Loading Dealers on State Changes
    const onSearch = (searchFilter: string, searchRadius?: number) => {
        setLocationSearchFilter(searchFilter);
        setRadiusSearchFilter(searchRadius);
    };

    const createFilter = (
        coords: google.maps.LatLng | undefined,
        searchFilter: string,
        searchRadius?: number,
    ): GetDealersApiParameter => {
        // Default center Point
        let centerPoint = { latitude: 0, longitude: 0 };
        // Passed in coords
        if (coords && coords.lat() !== 0 && coords.lng() !== 0) {
            centerPoint = {
                latitude: coords.lat(),
                longitude: coords.lng(),
            };
        }
        //  Selected Dealer
        if (centerPoint.latitude === 0 && centerPoint.longitude === 0 && selectedDealer) {
            centerPoint = {
                ...selectedDealer,
            };
        }
        // default Location
        if (
            centerPoint.latitude === 0 &&
            centerPoint.longitude === 0 &&
            dealersDefaultLocation.latitude !== 0 &&
            dealersDefaultLocation.latitude !== 0
        ) {
            centerPoint = dealersDefaultLocation;
        }

        return {
            name: searchFilter,
            latitude: centerPoint.latitude,
            longitude: centerPoint.longitude,
            radius: searchRadius,
            page,
            pageSize,
        };
    };
    const { locationSearchFilter, setLocationSearchFilter, setRadiusSearchFilter, page, pageSize } =
        useLocationFilterSearch<DealerModel, GetDealersApiParameter>({
            onSearch,
            loadLocations: handleLoadLocations,
            currentLocation,
            defaultRadius,
            selectedLocation: selectedDealer,
            setSelectedLocation: location => setSelectedDealer(location),
            setShowSelectedLocation: setShowSelectedDealer,
            createFilter,
        });
    React.useEffect(() => {
        if (!isGoogleMapsScriptsLoaded) {
            return;
        }
        if (dealersDataView.value && !dealersDataView.isLoading) {
            const { pagination, value: dealers, defaultRadius, defaultLatitude, defaultLongitude } = dealersDataView;
            // Find default location
            setLocationSearchFilter(locationSearchFilter);
            setDefaultRadius(defaultRadius);
            setRadiusSearchFilter(defaultRadius);
            setMapCenter(new google.maps.LatLng(defaultLatitude, defaultLongitude));
            setIsLoading(false);
        } else {
            setIsLoading(true);
        }
    }, [dealersDataView, isGoogleMapsScriptsLoaded]);

    React.useEffect(() => {
        if (isAuthenticated && pickUpWarehouse) {
            const getDealer = async () => {
                await getDealers({
                    radius: 5,
                    latitude: pickUpWarehouse.latitude,
                    longitude: pickUpWarehouse.longitude,
                } as GetDealersApiParameter).then(resp => {
                    if (resp.dealers) {
                        const location = resp.dealers[0];
                        if (location) {
                            sessionStorage.setItem(
                                "selectedLocationData",
                                JSON.stringify({
                                    location: location,
                                }),
                            );
                        }
                    }
                });
            };
            getDealer();
        }
    }, []);

    const [currentDealer, setCurrentDealer] = React.useState<LocationModel | undefined>(undefined);
    React.useEffect(() => {
        if (sessionStorage.getItem("selectedLocationData")) {
            const a = sessionStorage.getItem("selectedLocationData");
            let b: any;
            if (a != null) {
                b = JSON.parse(a);
                setCurrentDealer(b.location);
            }
        } else if (dealersDataView && dealersDataView.value) {
            sessionStorage.setItem(
                "selectedLocationData",
                JSON.stringify({
                    location: dealersDataView.value[0],
                }),
            );
        }
    }, [sessionStorage.getItem("selectedLocationData"), dealersDataView]);

    return (
        <StyledWrapper {...customCssWrapper}>
            <Hidden below="lg">
                <Navigation className="wrapper" {...styles.wrapper}>
                    <NavItem {...styles.signInLink}>
                        <Icon src={MapPin} size={16} />
                        {isAuthenticated && (
                            <span className="closest-title">
                                {translate("Your Branch: ")}
                                <span>
                                    {pickUpWarehouse?.name.replace(/\w+/g, function (w) {
                                        return w[0].toUpperCase() + w.slice(1).toLowerCase();
                                    })}
                                    , {pickUpWarehouse?.postalCode}{" "}
                                    <Link {...styles.wrapper} href={`tel:${pickUpWarehouse?.phone}`} target="_blank">
                                        {pickUpWarehouse?.phone}
                                    </Link>{" "}
                                </span>
                            </span>
                        )}
                        {!isAuthenticated && (
                            <span className="closest-title">
                                <>
                                    {currentDealer && (
                                        <>
                                            {translate("Branch closest to you: ")}
                                            <span>
                                                {currentDealer.name.replace(/\w+/g, function (w) {
                                                    return w[0].toUpperCase() + w.slice(1).toLowerCase();
                                                })}
                                                , {currentDealer.postalCode}{" "}
                                                <Link
                                                    {...styles.wrapper}
                                                    href={`tel:${currentDealer.phone}`}
                                                    target="_blank"
                                                >
                                                    {currentDealer.phone}
                                                </Link>{" "}
                                            </span>
                                        </>
                                    )}
                                    {!currentDealer &&
                                        dealersDataView &&
                                        dealersDataView.value &&
                                        dealersDataView.value.length > 0 && (
                                            <>
                                                {translate("Branch closest to you: ")}
                                                <span>
                                                    {dealersDataView.value[0].name.replace(/\w+/g, function (w) {
                                                        return w[0].toUpperCase() + w.slice(1).toLowerCase();
                                                    })}
                                                    , {dealersDataView.value[0].postalCode}{" "}
                                                    <Link
                                                        {...styles.wrapper}
                                                        href={`tel:${dealersDataView.value[0].phone}`}
                                                        target="_blank"
                                                    >
                                                        {dealersDataView.value[0].phone}
                                                    </Link>{" "}
                                                </span>
                                            </>
                                        )}
                                </>
                            </span>
                        )}
                        <span className="find-location">
                            <a href={dealersPageUrl}>{translate("Find Location")}</a>
                        </span>
                    </NavItem>
                </Navigation>
                <Zone contentId={id} zoneName="RichContent" />
            </Hidden>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withHistory(withDynamicGoogleMaps(NearestBranchInformation))),
    definition: {
        group: "Common",
        icon: "link-simple",
        fieldDefinitions: [
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default widgetModule;
